import { createApp } from 'vue'
import App from './App.vue'

import Ele from 'element-plus'
import zhCn from "element-plus/dist/locale/zh-cn.mjs"
import 'element-plus/dist/index.css'

import Router from "./plugins/router"
import Store from "./plugins/store"
import Areas from './plugins/area'

import Toolbar from "./pages/Toolbar"
import Dialog from './pages/Dialog'
import Price from './components/Price'
import Input from './components/Input'
import Index from './components/Index'
import File from './components/upload/File'
import Image from './components/upload/Image'
import Images from './components/upload/Images'
import Tags from './components/Tags'
import Location from './components/Location'


// import VueSocketIO from 'vue-socket.io';
// const socket = new VueSocketIO({
//     debug: true,
//     connection: 'www.599it.com:8282'
// });

//const socket = new WebSocket("wss://www.599it.com/wss");

const app = createApp(App);
        app.config.globalProperties.$areas = Areas;
       // app.config.globalProperties.$socket = socket;

        app.use(Ele,{
            locale:zhCn
        });
        app.use(Router);
        app.use(Store);

        app.mount("#app");
        app.component('el-toolbar',Toolbar);
        app.component('m-dialog',Dialog);
        app.component('m-price',Price);
        app.component('m-input',Input);
        app.component('m-component',Index);
        app.component('m-file',File);
        app.component('m-image',Image);
        app.component('m-images',Images);
        app.component('m-tags',Tags);
        app.component('location',Location);

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
}
